module.exports = __webpack_public_path__ + "e937401ded86517f45e7ffb307992cdf.svg";